import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";

import { useIsSelfServeHomePage } from "../../hooks/useIsSelfServeHomePage";

import {
  IconWrapper,
  IssueTopicCardButtonWrapper,
  IssueTopicCardInnerWrapper,
  TypographyWrapper,
} from "./styles";
import { IIssueTopicCardProps } from "./type";

export const IssueTopicCard: React.FC<IIssueTopicCardProps> = ({
  icon,
  text,
  linkTo,
  isSelected,
  dataTestId,
  onClick,
  buttonRef,
  style,
}) => {
  const isSelfServeHomePage = useIsSelfServeHomePage();
  return (
    <IssueTopicCardButtonWrapper
      linkTo={linkTo}
      onClick={onClick}
      $isSelected={isSelected}
      data-test-id={dataTestId}
      $homePage={isSelfServeHomePage}
      buttonRef={buttonRef}
      style={{ ...style }}
    >
      <IssueTopicCardInnerWrapper>
        {icon ? (
          <>
            <IconWrapper>{icon}</IconWrapper>
            <Spacer width="2x" />
          </>
        ) : null}
        <TypographyWrapper>{text}</TypographyWrapper>
      </IssueTopicCardInnerWrapper>
    </IssueTopicCardButtonWrapper>
  );
};
